<template>
    <validation-provider
        v-slot="{ errors }"
        name="Número"
        :rules="rules"
    >
        <b-form-group label="Número" label-for="numero-input">
            <b-form-input
                id="numero-input"
                v-model="selected"
                placeholder="Informe o número"
                :disabled="desabilitarCamposDadosCriacao"
            />
            <small v-if="errors.length" class="text-danger d-block">{{ errors[0] }}</small>
        </b-form-group>
    </validation-provider>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate'

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
        desabilitarCamposDadosCriacao: {
          type: Boolean,
          required: false,
          default: false,
        },
    },
    components: {
        BFormGroup, BFormInput, ValidationProvider
    },
    data() {
        return {
            selected: null,
            rules: 'min:1|max:6',
        }
    },
    mounted() {
        this.selected = this.value
    },
    watch: {
        selected: function (val) {
            this.$emit('updated', val);
        }
    }
}
</script>